<iframe *ngIf="cartographicConsoleUrl" [src]="cartographicConsoleUrl"></iframe>
